import Uploader from './Uploader'
import './index.less'

export default Uploader
